<template>
  <div
    :class="[type && `icon-shape-${type}` && `${type}Light`]"
    class="icon icon-shape mb-4 rounded-circle"
    :style="{ background: colorLight }"
  >
    <i :class="[name, type]"></i>
  </div>
</template>
<script>
export default {
  name: "round-icon",
  props: {
    name: {
      type: String,
      default: "",
      description: "Icon name",
    },
    type: {
      type: String,
      default: "",
      description: "Icon type (primary, warning etc)",
    },
  },
  async created() {
    window.addEventListener("theme", () => {
      this.color = this.$theme[this.type];
      this.colorLight = this.$theme[this.type + 'Light']
    });
  },
  data() {
    return {
      color: this.$theme[this.type],
      colorLight: this.$theme[this.type + 'Light']
    };
  },
};
</script>
